import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tailwind.css';
import App from './App';
import { initializeApiMode } from './utils/migrateToApi';

// Initialize application to use API mode instead of localStorage
initializeApiMode().then(success => {
  if (success) {
    console.log("Application initialized to use backend API");
  } else {
    console.warn("Failed to initialize API mode, application may use fallback data");
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);